module.exports = __webpack_public_path__ + "src/assets/img/page10/9bfe352c2f2815e3cf8b9859e1de96c2.png";